import { GlobalOutlined } from "@ant-design/icons";
import type { I18nText } from "@/api/products";
import { hasI18nExtra } from "../rules";

export function I18nGlobe({
  text,
  onClick,
}: {
  text: I18nText;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className={`border-none bg-transparent p-1 ${hasI18nExtra(text) ? "text-brand-indigo" : "text-muted"}`}
      onClick={onClick}
    >
      <GlobalOutlined />
    </button>
  );
}
